module.exports = __webpack_public_path__ + "assets/img/Clementi Forest.594246c4.jpg";